import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { uploadDocumentService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'uploadQualityDoc',
  initialState: adapter.getInitialState({
    busy: false,
    dirty: true,
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
    setDirty(state, action) {
      let dirty = action.payload;
      state.dirty = dirty;
    },
  },
});

const fetchList = (qualityId) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await uploadDocumentService.fetchQualityLabList(qualityId);

    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    console.log('Redux-uploadDocumentService->Err', err);
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};
const fetchManualInvoiceDocumentList = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await uploadDocumentService.fetchManualInvoiceDocumentList(params);

    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    console.log('Redux-uploadDocumentService->Err', err);
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};
const actions = {
  ...slice.actions,
  fetchList,
  fetchManualInvoiceDocumentList,
};

const selectors = {
  ...adapter.getSelectors((state) => state.uploadBanner),
};

export { actions, selectors };

export default slice.reducer;
